'use client'

// libraries
import { useRef } from 'react'
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'

// utils
import { formatNumber } from '/react4xp/utils/functions'

// types
export interface CounterProps {
    number: number
}

export default function Counter({
    number
}: CounterProps) {

    const item = useRef<HTMLSpanElement>(null)

    useGSAP(() => {
        if (!item.current) return
        
        // Set initial value to 0
        item.current.textContent = formatNumber(0)
        
        // Set up Intersection Observer
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Create an object to animate the number value
                        const counterObj = {
                            value: 0
                        }
                        
                        gsap.to(counterObj, {
                            value: number,
                            duration: 2,
                            ease: 'power2.inOut',
                            onUpdate: () => {
                                if (item.current) {
                                    item.current.textContent = formatNumber(counterObj.value)
                                }
                            }
                        })

                        // Stop observing after animation triggers
                        observer.unobserve(entry.target)
                    }
                })
            },
            {
                threshold: 0.1, // Trigger when 10% of element is visible
                rootMargin: '0px 0px -10% 0px' // Similar to start: 'top 90%'
            }
        )

        // Observe the counter element
        observer.observe(item.current)

        // Cleanup function
        return () => {
            observer.disconnect()
        }
	})

    return (
        <span ref={item}>
            {formatNumber(0)}
        </span>
    )
}